import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
import ConfigurationMarkdown from "@/components/ObjectStore/ConfigurationMarkdown.vue";
import ObjectStoreBadges from "@/components/ObjectStore/ObjectStoreBadges.vue";
import ObjectStoreTypeSpan from "@/components/ObjectStore/ObjectStoreTypeSpan.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'TemplateSummary',
    props: {
        template: null
    },
    setup(__props) {
        const props = __props;
        const badges = computed(() => props.template.badges);
        const objectStoreType = computed(() => props.template.type);
        return { __sfc: true, props, badges, objectStoreType, ConfigurationMarkdown, ObjectStoreBadges, ObjectStoreTypeSpan };
    }
});
